import { useEffect, useState } from 'react';
import { onDocDeleted } from '../doc-deleted-bus';

export type DocDeletedStatus =
  | { state: 'alive' }
  | { state: 'deleted-remotely' };

export function useDocDeletedStatus(id: string | null): DocDeletedStatus {
  const [status, setStatus] = useState<DocDeletedStatus>({ state: 'alive' });

  useEffect(() => {
    if (!id) { setStatus({ state: 'alive' }); return; }
    setStatus({ state: 'alive' });
    return onDocDeleted((deletedId, actor) => {
      if (deletedId === id && actor === 'remote') {
        setStatus({ state: 'deleted-remotely' });
      }
    });
  }, [id]);

  return status;
}
